export default __webpack_public_path__ + "95e5b71009ff38880f348e71c009f50d.png";